'use client';

import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => (
  <Sonner
    className="toaster group"
    toastOptions={{
      classNames: {
        toast:
          'group toast group-[.toaster]:bg-white group-[.toaster]:text-black group-[.toaster]:border-white/10 group-[.toaster]:shadow-lg',
        description: 'group-[.toast]:text-black/60',
        actionButton: 'group-[.toast]:bg-black group-[.toast]:text-white',
        cancelButton: 'group-[.toast]:bg-gray-100 group-[.toast]:text-black',
      },
    }}
    {...props}
  />
);

export { Toaster };
